import { cloneDeep } from 'lodash';
import { selector } from 'recoil';

import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { currentTeam } from '../atoms/currentTeam';
import { endingDate } from '../atoms/endingDate';
import { startingDate } from '../atoms/startingDate';

import {
  makePHPRequest,
  methodNameEnum,
  refetchToggle,
} from './makePHPRequest';
export const dispositionSelector = selector({
  key: 'dispositionSelector',
  get: async ({ get }) => {
    get(refetchToggle(dispositionSelector));

    const result = { allStats: [] };
    const startdate = get(startingDate);
    const enddate = get(endingDate);
    const current = get(currentTeam);

    const businessData = get(
      makeAPIRequest({
        endpoint: endpointEnum.GET_BUSINESS_DATA,
        payloadJsonString: JSON.stringify({
          call: methodNameEnum.GET_BUSINESS_DATA,
        }),
      })
    );

    const timezone = businessData?.response?.data?.result?.[0]?.timezone_php;

    const UserDisposition = get(
      makePHPRequest({
        methodName: methodNameEnum.GET_USER_DISPOSITION_REPORTING,
        payloadJsonString: JSON.stringify({
          startdate,
          enddate,
          timezone,
        }),
        waitForPayload: !timezone,
      })
    );

    const BusinessUsers = get(
      makeAPIRequest({
        endpoint: endpointEnum.GET_BUSINESS_USERS,
        payloadJsonString: JSON.stringify({
          call: methodNameEnum.GET_BUSINESS_USERS,
        }),
      })
    );

    const activeUsers =
      BusinessUsers?.response?.data?.result?.filter(
        (user) => user.isactive === 1
      ) || [];

    const dispos = cloneDeep(UserDisposition);
    const stats = dispos?.data?.dispositionStats || {};
    const columns = dispos?.data?.dispositions?.dispositionArr;
    result.columns = columns;

    const addStatIfNeeded = (user) => {
      const stat = stats[user.userid];
      if (!stat) return;

      // Fill in missing columns with 0
      result.columns.forEach((col) => {
        stat[col] = stat[col] || 0;
      });

      stat.email = user.email;
      result.allStats.push(stat);
    };

    if (current.id !== 0) {
      const addedUserIds = new Set();

      activeUsers?.forEach((user) => {
        if (stats[`${user.userid}`] && user.teams) {
          const splitTeams = [
            ...new Set(user.teams.split(',').map((id) => parseInt(id, 10))),
          ];
          if (
            splitTeams.includes(current.id) &&
            !addedUserIds.has(user.userid)
          ) {
            addStatIfNeeded(user);
            addedUserIds.add(user.userid);
          }
        }
      });
    } else {
      activeUsers?.forEach(addStatIfNeeded);
    }
    return result;
  },
});
